export const chevron = `
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18"><path class="container" fill="#fff" d="M9 17 1 9l8-8"/><path class="shape" fill="#222" d="M9 0a1 1 0 0 1 .707 1.707L2.414 9l7.293 7.293a1 1 0 0 1-1.414 1.414l-8-8a1 1 0 0 1 0-1.414l8-8A1 1 0 0 1 9 0Z" data-name="Chevron_Previous - Outline"/></svg>
`
